import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PackageStatusText from 'components/PackageStatusText';
import { Options } from 'lib';

import { PackageStatus as PackageStatusType } from '__generated__/PackageListRow_package.graphql';
import { PackageStatus_package$key } from '__generated__/PackageStatus_package.graphql';

export const optionsConfig: Options<PackageStatusType> = {
  DRAFT: {
    label: 'Ruošinys',
    color: 'info',
  },
  EXPIRED: {
    label: 'Pasibaigęs galiojimas',
    color: 'error',
  },
  PUBLISHED: {
    label: 'Publikuotas',
    color: 'success',
  },
  WAITING: {
    label: 'Neprasidėjęs',
    color: 'warning',
  },
};

type Props = {
  package: PackageStatus_package$key;
};

const PackageStatus: FC<Props> = props => {
  const { status } = useFragment(
    graphql`
      fragment PackageStatus_package on Package {
        status
      }
    `,
    props.package
  );

  return <PackageStatusText status={status} />;
};

export default PackageStatus;
